import { Controller } from "@hotwired/stimulus"

// The Guest List headcount warning: the banner under the filter pills and the
// badge beside the heading, which both open and close it.
//
// A warning (over, or could go over) starts expanded; collapsing it
// acknowledges those exact numbers, so it reopens once they change. On track
// starts collapsed and stays open only while the numbers it was opened on
// hold. The choice is kept per event in this browser. Stats turbo streams
// replace the banner, so everything re-applies when its targets reconnect,
// and the badge is refreshed from the banner's template.
export default class extends Controller {
  static targets = ["badge", "badgeSource", "banner", "collapsed", "expanded"]
  static values = { eventId: String }

  bannerTargetConnected() {
    this.render()
  }

  badgeSourceTargetConnected(template) {
    if (this.hasBadgeTarget) this.badgeTarget.innerHTML = template.innerHTML
    this.render()
  }

  toggle() {
    if (!this.hasBannerTarget) return

    const key = this.bannerTarget.dataset.key
    this.save(this.isExpanded() ? { ack: key, open: "" } : { ack: "", open: key })
    this.render()
  }

  render() {
    if (!this.hasBannerTarget) return

    const open = this.isExpanded()
    this.bannerTarget.dataset.expanded = String(open)
    if (this.hasCollapsedTarget) this.collapsedTarget.classList.toggle("hidden", open)
    if (this.hasExpandedTarget) this.expandedTarget.classList.toggle("hidden", !open)

    if (this.hasBadgeTarget) {
      const button = this.badgeTarget.querySelector("button")
      button?.setAttribute("aria-expanded", String(open))
      this.badgeTarget.querySelector("[data-headcount-caret]")?.classList.toggle("rotate-180", open)
    }
  }

  isExpanded() {
    const { key, status } = this.bannerTarget.dataset
    const state = this.load()

    if (state.ack === key) return false
    return status === "within" ? state.open === key : true
  }

  get storageKey() {
    return `kaganapn:headcount:${this.eventIdValue}`
  }

  load() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || {}
    } catch (_) {
      return {}
    }
  }

  save(state) {
    try { localStorage.setItem(this.storageKey, JSON.stringify(state)) } catch (_) {}
  }
}
